import { axios } from '@/utils/request'

export default{
    getSale(){
        return axios.get('/api/services/app/DashBoard/GetSales')
    },
    getStudents(){
        return axios.get('/api/services/app/DashBoard/GetStudents')
    },
    getLessons(){
        return axios.get('/api/services/app/DashBoard/GetLessons')
    },
    getStudyLessons(){
        return axios.get('/api/services/app/DashBoard/GetStudyLessons')
    }
}